import { render, staticRenderFns } from "./EditMemberModal.vue?vue&type=template&id=48b9c426&"
import script from "./EditMemberModal.vue?vue&type=script&lang=js&"
export * from "./EditMemberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports